import { Context3cPlusProvider } from "contexts/Context3cPlus";
import { useRouter } from "router-manager/parts";
import { AttendanceProvider } from "contexts/attendance-context";
import { getEventListeners, makeEvent } from "services/events";
import { ToastContainer } from "components/toast";
import "../components/toast/style.css";
import { powerhubConfig } from "utils/project-configuration";
import { ModalConfirm } from "components/modal-confirm-new";
import { ModalFields } from "components/modal-fields";
import { ModalError } from "components/modal-error";
import { ModalInfo } from "components/modal-info";
import { ModalUploadFile } from "components/modal-upload-file";
import { ModalCSVReader } from "components/mailing-components/csv-reader";
import { ModalAlerts } from "components/modal-alerts";

powerhubConfig();

export default function PageTemplate({
  PageComponent
}: {
  PageComponent: () => JSX.Element;
}) {
  const attendanceRoutes = ["/atendimentos", "/atendimento-cliente-page"];

  const router = useRouter();

  return (
    <main
      onClickCapture={(e) => {
        if (getEventListeners("globalOnClick")) makeEvent("globalOnClick", e);
        if (getEventListeners("blur-popover")) makeEvent("blur-popover", e);
        if (getEventListeners("onClickBody")) makeEvent("onClickBody", e);
      }}
    >
      <ToastContainer />
      <ModalConfirm />
      <ModalFields />
      <ModalError />
      <ModalInfo />
      <ModalUploadFile />
      <ModalCSVReader />
      <ModalAlerts />

      {attendanceRoutes.includes(router.pathname) ? (
        <Context3cPlusProvider>
          <AttendanceProvider>
            <PageComponent />
          </AttendanceProvider>
        </Context3cPlusProvider>
      ) : (
        <PageComponent />
      )}
    </main>
  );
}
